import { Client } from "../../../client";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { proccessErrorMessage } from "../../../Helper/proccessErrorMessage";
import { API_HALAL_STOCKS } from "../../../config/api";

export const createStock = createAsyncThunk(
  "stocks/create",
  async ({ data, navigate, setSubmitting }, { rejectWithValue }) => {
    try {
      const response = await Client({
        method: "POST",
        path: API_HALAL_STOCKS,
        data: data,
        contentType: "multipart/form-data",
        serializerConfig: { indexes: null },
      });
      toast.success("Stock created successfully");
      navigate("/stocks", { replace: true });
      return response?.data;
    } catch (error) {
      const msg = proccessErrorMessage(error);
      toast.error(msg);
      setSubmitting && setSubmitting(false);
      return rejectWithValue(error.message);
    }
  }
);
